import { SelectBox } from "components/uikit-adapter";
import { gridParameterizationType } from "pages/master-data/unit-management/grid-parameterization/utils";
import intl from "react-intl-universal";
import type { IOption } from "types/option";
import { useGridParameterizationContext } from "../../../../context";
import { SelectBoxWrapper } from "../../styled";
import SelectableAndSearchableList from "../selectable-and-searchable-list";

const LoadCapacityFilter = () => {
  const { businessUnits, suppliers, filtersLoadCapacity, handleChangeFilter } =
    useGridParameterizationContext();

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <SelectBoxWrapper>
        <SelectBox
          label={intl.get("commons.businessUnit")}
          placeholder={intl.get("commons.businessUnit")}
          valueKey="Id"
          labelKey="Description"
          options={businessUnits}
          onChange={(value: IOption) =>
            handleChangeFilter(gridParameterizationType.LoadCapacity, "businessUnitId", value?.Id)
          }
          name="business-unit-selectbox"
          value={filtersLoadCapacity.businessUnitId}
          required
        />
      </SelectBoxWrapper>
      <SelectableAndSearchableList
        type={gridParameterizationType.LoadCapacity}
        prop={"supplierId"}
        data={suppliers}
        filters={filtersLoadCapacity}
      />
    </div>
  );
};

export default LoadCapacityFilter;
